<template>
  <div class="container" id="personalContainer">
    <div class="personal">
      <img src="../assets/location.png" />
      个人信息
    </div>
    <div class="userInfo">
      <div class="avatar">
        <img v-if="this.userInfo.head" :src="this.userInfo.head" alt />
        <img v-else src="../assets/avatar.png" />
        <!-- <img :src="this.userInfo.head === '' ? '../assets/avatar.png' : this.userInfo.head " /> -->
      </div>
      <div class="departmentInfo">
        <div class="username">{{this.userInfo.realname}}</div>
        <div class="info">
          <span>
            <i>账号ID：</i>
            {{this.userInfo.phone}}
          </span>
          <span>
            <i>所属部门：</i>
            {{this.userInfo.dept}}
          </span>
          <span>
            <!-- <i>部门管理员：</i>Jack -->
          </span>
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="material">
        <div>
          <img src="../assets/material.png" alt />
          <span class="title">个人资料信息</span>
        </div>
        <div class="itemRight">
          <span class="point">已完善</span>
          <span class="modify" @click="modifyMaterial">修改</span>
        </div>
      </div>
      <div class="signature">
        <div>
          <img src="../assets/signature.png" alt />
          <span class="title">个人签名设置</span>
          <span class="prompt">| 用于事件签批</span>
        </div>
        <div class="itemRight">
          <span class="point">{{isSignature ? '已完善' : '去完善'}}</span>
          <span class="modify" @click="modifySignature">{{isSignature ? '修改' : '添加'}}</span>
        </div>
      </div>
      <div class="account">
        <div>
          <img src="../assets/account.png" alt />
          <span class="title">个人手机号码</span>
          <span class="prompt">| 用于联络</span>
        </div>
        <div class="itemRight">
          <span class="point">{{isPhone ? '已完善' : '去完善'}}</span>
          <span class="modify" @click="modifyAccount">{{isPhone ? '修改' : '添加'}}</span>
        </div>
      </div>
      <div class="password">
        <div>
          <img src="../assets/password.png" alt />
          <span class="title">登录密码</span>
          <span class="prompt">| 设置密码长度</span>
        </div>
        <div class="itemRight">
          <span class="point">已完善</span>
          <span class="modify" @click="modifyPassword">修改</span>
        </div>
      </div>
      <div class="addressList">
        <div>
          <img src="../assets/addressList.png" alt />
          <span class="title">通讯录</span>
        </div>
        <div class="itemRight">
          <span class="point"></span>
          <span class="modify" @click="showAddressList">查看</span>
        </div>
      </div>
    </div>
    <div class="logout" @click="logout">退出登录</div>
    <!-- 个人资料对话框 -->
    <el-dialog :visible.sync="materialDialogVisible" width="600px" @close="dialogClose">
      <template #title>
        <div class="dialogHeader">
          <img src="../assets/popup_icon.png" alt />
          <div>个人资料</div>
        </div>
      </template>
      <el-form
        :model="materialForm"
        status-icon
        ref="materialRuleForm"
        label-width="82px"
        label-position="left"
      >
        <el-form-item label="姓名：">
          <el-input v-model="materialForm.realname"></el-input>
        </el-form-item>
        <el-form-item label="角色：">
          <el-select
            v-model="roleId"
            :disabled="isSelect"
            :placeholder="isSelect === true ? '请先选择部门' : '请选择'"
            style="width:100%;"
          >
            <el-option
              v-for="item in materialForm.role"
              :key="item.gid"
              :label="item.name"
              :value="item.gid"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="性别：">
          <el-radio v-model="materialForm.gender" label="1">男</el-radio>
          <el-radio v-model="materialForm.gender" label="2">女</el-radio>
        </el-form-item>-->
        <el-form-item label="头像：">
          <el-upload
            action="http://192.168.0.118:18091/self/upload"
            :on-change="changeAvatar"
            :show-file-list="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="所属部门：">
          <el-select
            v-model="depaValue"
            placeholder="请选择"
            style="width:100%;"
            @change="selectDepart"
          >
            <el-option
              v-for="item in materialForm.department"
              :key="item.gid"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" style="width:65%;" class="modifyBtn" @click="submitUserInfo">确认</el-button>
      </template>
    </el-dialog>
    <!-- 个人签名对话框 -->
    <el-dialog
      :visible.sync="signatureDialogVisible"
      width="600px"
      @close="signatureDialogClose"
      :close-on-click-modal="false"
    >
      <template #title>
        <div style="text-align:center;font-size:16px;font-weight:500;">签名</div>
      </template>
      <el-form
        :model="signatureForm"
        status-icon
        ref="signatureRuleForm"
        label-width="82px"
        label-position="left"
      >
        <el-form-item label="真实姓名：">
          <el-input v-model="signatureForm.realname"></el-input>
        </el-form-item>
        <el-form-item label="签名：">
          <div class="pic" v-if="isShow2">
            <img :src="this.userInfo.signature" alt />
            <div class="modifySignature">
              <el-button size="mini" @click="cutover">修改签名</el-button>
            </div>
          </div>
          <Signature
            @mouseenter="mouseenter"
            @mousedown="mousedown($event)"
            @mousemove="mousemove($event)"
            @mouseup="mouseup"
            @mouseout="mouseout"
            @revoke="revokeSignature"
            @reset="resetSignature"
            :isShowCanvas="isShowCanvas"
            ref="signature"
            v-else
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" style="width:65%;" class="modifyBtn" @click="submitSignature">修改</el-button>
      </template>
    </el-dialog>
    <!-- 手机号对话框 -->
    <el-dialog :visible.sync="accountDialogVisible" width="600px" @close="dialogClose">
      <template #title>
        <div class="dialogHeader">
          <img src="../assets/popup_icon.png" alt />
          <div>修改手机号</div>
        </div>
      </template>
      <el-form
        :model="phoneForm"
        status-icon
        ref="phoneRuleForm"
        label-width="82px"
        label-position="left"
      >
        <el-form-item label="新手机号：">
          <el-input v-model="phoneForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" style="width:65%;" class="modifyBtn" @click="submitPhone">确认</el-button>
      </template>
    </el-dialog>
    <!-- 登录密码对话框 -->
    <el-dialog :visible.sync="passwordDialogVisible" width="600px" @close="dialogClose">
      <template #title>
        <div class="dialogHeader">
          <img src="../assets/popup_icon.png" alt />
          <div>修改密码</div>
        </div>
      </template>
      <el-form
        :model="passwordForm"
        status-icon
        ref="passwordRuleForm"
        label-width="82px"
        label-position="left"
      >
        <el-form-item label="旧密码：">
          <el-input type="password" v-model="passwordForm.oldPwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input type="password" v-model="passwordForm.newPwd"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：">
          <el-input type="password" v-model="passwordForm.confirmPwd"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" style="width:65%;" class="modifyBtn" @click="submitNewPwd">确认</el-button>
      </template>
    </el-dialog>
    <!-- 通讯录对话框 -->
    <el-dialog :visible.sync="addressDialogVisible" width="765px" @close="dialogClose">
      <template #title>
        <div class="dialogHeader">
          <img src="../assets/popup_icon.png" alt />
          <div>通讯录</div>
        </div>
      </template>
      <el-input
        placeholder="请输入部门名称"
        clearable
        v-model="inputVal"
        style="margin-bottom:16px;"
        @clear="clearInput"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchDept"></el-button>
      </el-input>
      <div class="error" v-if="isError">请输入正确的部门名</div>
      <el-collapse @change="handleChange" accordion>
        <el-collapse-item :name="item.name" v-for="item in materialForm.department" :key="item.gid">
          <template #title>
            <span>{{item.name}}</span>
            <span class="deptPhone" v-if="item.phone">| 部门电话：{{item.phone}}</span>
          </template>
          <div class="collapseItem" v-for="(subItem,index) in deptMember" :key="index">
            <span class="name">{{subItem.realname}}</span>
            <span class="online">{{subItem.status === 0 ? '' : '在线'}}</span>
            <span class="post">{{subItem.rolename}}</span>
            <span class="telephone">{{subItem.phone}}</span>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { localStorageUtil } from "../utils/storage";
import { getServerData } from "../utils/fetchData";
import { APIMAP } from "../constants/apiConstants";
import Signature from "@/components/Canvas/Signature";
import { dataURLtoBlob } from '@/utils/util'
export default {
  name: "PersonalCenter",
  components: {
    Signature,
  },
  data() {
    return {
      materialDialogVisible: false,
      signatureDialogVisible: false,
      accountDialogVisible: false,
      passwordDialogVisible: false,
      addressDialogVisible: false,
      materialForm: {
        realname: "",
        role: [],
        department: [],
      },
      signatureForm: {
        realname: "",
      },
      phoneForm: {
        phone: "",
      },
      passwordForm: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
      },
      inputVal: "",
      imageUrl: "",
      flag: false,
      isShowCanvas: false,
      startPoint: {}, // 开始坐标
      canvasHistory: [], // 完成一次绘制操作则保存一份 canvas 快照到 canvasHistory 数组
      step: -1, // 记录绘图的步骤
      depaValue: "", // 部门值
      roleId: "", // 角色id
      signatureSrc: "", // 签名图片地址
      isShowImg: false,
      deptMember: [], // 部门成员
      isError: false,
      isShow2: null,
    };
  },
  mounted() {
    // 如果是从事件流转过来 默认打开签名
    const { showSign } = this.$route.query;
    if (showSign) {
      this.signatureDialogVisible = true;
    }
    console.log(this.userInfo,'iiiii')
  },
  created() {
    this.phoneForm.phone = this.userInfo.phone;
    this.materialForm.realname = this.userInfo.realname;
    this.signatureForm.realname = this.userInfo.realname;
    this.isShow2 = this.userInfo.signature === "" ? false : true;
  },
    computed: {
    ...mapState(["userInfo"]),
    isSelect() {
      if (this.depaValue === "") return true;
      return false;
    },
    isSignature() {
      if (this.userInfo.signature === "") return false;
      return true;
    },
    isPhone(){
      if(this.userInfo.phone === '') return false;
      return true;
    }
  },
  methods: {
    ...mapMutations(["SET_USER_INFO", "SET_TOKEN"]),
    // 修改个人资料
    modifyMaterial() {
      this.getDepartment();
      this.materialDialogVisible = true;
    },
    // 提交修改后的个人信息
    async submitUserInfo() {
      try {
        const {
          materialForm: { realname },
          roleId,
          imageUrl,
        } = this;
        const params = {};
        params.realname = realname;
        params.rid = roleId;
        params.gid = this.userInfo.gid;
        params.head = imageUrl;
        console.log("请求参数", params);
        const key = Object.keys(params);
        for (let i = 0; i < key.length; i++) {
          if (params[key[i]] === "") return this.$message.error("请填写完整");
        }
        const res = await getServerData(APIMAP.MEMBER, params, "put");
        console.log("返回数据", res);
        const rolename = this.materialForm.role.filter(
          (item) => item.gid === params.rid
        )[0].name;
        this.userInfo["realname"] = params.realname;
        this.userInfo["rolename"] = rolename;
        this.userInfo["head"] = params.head;
        // 更新本地和vuex中的信息
        localStorageUtil.save("saasViewUserInfo", this.userInfo);
        this.SET_USER_INFO(this.userInfo);
        this.materialDialogVisible = false;
        this.$message.success("修改成功");
      } catch (error) {
        console.log(error);
      }
    },
    // 修改签名
    modifySignature() {
      this.signatureDialogVisible = true;
    },
    // 保存并提交签名
    async submitSignature() {
      if (this.canvasHistory.length > 0) {
        // this.isShowImg = true;
        this.signatureSrc = this.canvasHistory[this.canvasHistory.length - 1];
        const blob = dataURLtoBlob(this.signatureSrc);
        const res1 = await getServerData(
          APIMAP.UPLOAD,
          {
            file: blob,
            type: 1,
            pid: this.userInfo.platformid,
          },
          "post",
          0,
          true
        );
        console.log(res1, "res1", blob);
        const params = {};
        params.gid = this.userInfo.gid;
        params.realname = this.signatureForm.realname;
        params.signature = res1.url;
        console.log("请求参数", params);
        const res2 = await getServerData(APIMAP.MEMBER, params, "put");
        console.log("返回数据", res2);
        this.userInfo.signature = res1.url;
        localStorageUtil.save("saasViewUserInfo", this.userInfo);
        this.SET_USER_INFO(this.userInfo);
        this.isShow2 = true;
        this.$message.success("修改成功");
      }
    },
    // 修改手机号
    modifyAccount() {
      this.accountDialogVisible = true;
    },
    async submitPhone() {
      const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!reg.test(this.phoneForm.phone.trim())) {
        this.phoneForm.phone = this.userInfo.phone;
        return this.$message.error("手机号不合法");
      }
      if (this.phoneForm.phone.trim() !== "") {
        try {
          const params = {};
          params.phone = this.phoneForm.phone;
          params.gid = this.userInfo.gid;
          console.log("请求参数", params);
          const res = await getServerData(APIMAP.MEMBER, params, "put");
          console.log("返回数据", res);
          this.userInfo["phone"] = params.phone;
          localStorageUtil.save("saasViewUserInfo", this.userInfo);
          this.SET_USER_INFO(this.userInfo);
          this.accountDialogVisible = false;
          this.$message.success("修改成功");
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 选择头像
    async changeAvatar(file, fileList) {
      console.log(file, fileList);
      if (fileList.length === 0) return;
      const params = {};
      params.file = file.raw;
      params.pid = this.userInfo.platformid;
      params.type = "1";
      console.log("图片上传的参数", params);
      try {
        const res = await getServerData(APIMAP.UPLOAD, params, "post", 0, true);
        console.log("图片上传返回的结果", res);
        const { url } = res;
        this.imageUrl = url;
      } catch (error) {
        console.log(error);
      }
    },
    // 修改密码
    modifyPassword() {
      this.passwordDialogVisible = true;
    },
    async submitNewPwd() {
      const { oldPwd, newPwd, confirmPwd } = this.passwordForm;
      if (
        oldPwd.trim() !== "" &&
        newPwd.trim() !== "" &&
        confirmPwd.trim() !== ""
      ) {
        if (newPwd === confirmPwd) {
          try {
            const params = {};
            params.gid = this.userInfo.gid;
            params.oldPassword = oldPwd;
            params.newPassword = newPwd;
            console.log("请求参数", params);
            const res = await getServerData(
              APIMAP.MEMBER + `/pwd`,
              params,
              "put"
            );
            console.log("返回数据", res);
            this.$router.push({ path: "/login" });
            this.$notify({
              title: "修改密码成功",
              message: "请重新登录",
              type: "success",
              duration: 3000,
              position: "top-right",
            });
          } catch (error) {
            this.$message.error("旧密码错误或接口错误");
            console.log(error);
          }
        } else {
          return this.$message.error("两次输入的密码不一致");
        }
      } else {
        return this.$message.error("请填写完整");
      }
    },
    // 查看通讯录
    showAddressList() {
      this.getDepartment();
      this.addressDialogVisible = true;
    },
    // 对话框关闭,初始化数据
    dialogClose() {
      this.materialForm.role = [];
      this.materialForm.department = [];
      this.passwordForm.oldPwd = "";
      this.passwordForm.newPwd = "";
      this.passwordForm.confirmPwd = "";
      this.inputVal = "";
      this.imageUrl = "";
      this.depaValue = "";
      this.roleId = "";
      this.deptMember = [];
      this.isError = false;
    },
    // 展开部门项
    async handleChange(val) {
      if (val === "") return;
      try {
        const params = {};
        params.dept = val;
        params.eid = this.userInfo.eid;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.MEMBER + `/dept`, params);
        console.log("返回数据", res);
        this.deptMember = res;
      } catch (error) {
        console.log(error);
      }
    },
    mouseenter() {
      this.isShowCanvas = true;
      this.$nextTick(() => {
        this.canvas = this.$refs.signature.$refs.canvas;
        this.ctx = this.canvas.getContext("2d");
      });
    },
    // 签名
    mousedown(e) {
      this.flag = true;
      // 第一次点击的坐标
      const x = e.offsetX;
      const y = e.offsetY;
      this.startPoint = { x, y };
    },
    mousemove(e) {
      if (this.flag) {
        // 鼠标移动的坐标
        const x = e.offsetX;
        const y = e.offsetY;
        const newPoint = { x, y };
        // 画线
        this.drawLine(
          this.startPoint.x,
          this.startPoint.y,
          newPoint.x,
          newPoint.y
        );
        this.startPoint = newPoint;
      }
    },
    mouseup() {
      const { canvas, canvasHistory } = this;
      if (this.flag) {
        this.step++;
        canvasHistory.push(canvas.toDataURL());
        // console.log(canvasHistory);
        this.flag = false;
      }
    },
    mouseout() {
      this.flag = false;
    },
    // 画线
    drawLine(x1, y1, x2, y2) {
      const { ctx } = this;
      ctx.beginPath(); // 起始一条路径
      ctx.moveTo(x1, y1);
      ctx.strokeStyle = "black";
      ctx.lineWidth = 3; //线宽
      ctx.lineTo(x2, y2);
      ctx.stroke(); // 绘制已定义的路径
      ctx.closePath();
    },
    // 重置画板
    resetSignature() {
      const { ctx, canvas } = this;
      ctx && ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.step = -1;
      this.canvasHistory = [];
      this.startPoint = {};
    },
    // 撤销
    revokeSignature() {
      const { ctx, canvas, canvasHistory } = this;
      if (this.step >= 0) {
        this.step--;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const canvasPic = new Image();
        canvasPic.src = canvasHistory[this.step];
        canvasPic.addEventListener("load", () => {
          ctx.drawImage(canvasPic, 0, 0);
        });
      }
      if (this.step === -1) {
        // 全部撤销了
        this.canvasHistory = [];
        this.startPoint = {};
      }
    },
    // BASE64转二进制
    // dataURLtoBlob(base64) {
    //   const arr = base64.split(",");
    //   // const mime = arr[0].match(/:(.*?);/)[1];
    //   const bstr = atob(arr[1]);
    //   let n = bstr.length;
    //   const u8arr = new Uint8Array(n);
    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n);
    //   }
    //   return new Blob([u8arr], {
    //     type: "image/png",
    //   });
    // },
    cutover() {
      this.isShow2 = !this.isShow2;
    },
    // 个人签名对话框关闭
    signatureDialogClose() {
      this.resetSignature();
      this.isShowCanvas = false;
      this.isShow2 = true;
    },
    // 退出登录
    async logout() {
      const res = await this.$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (res === "confirm") {
        localStorageUtil.remove("saasViewToken");
        localStorageUtil.remove("saasViewUserInfo");
        // localStorageUtil.remove("isRemember");
        this.SET_USER_INFO({});
        this.SET_TOKEN(null);
        this.$router.push({
          path: "/login",
        });
        location.reload();
        this.$notify({
          title: "退出成功",
          message: "欢迎下次再来",
          type: "success",
          duration: 3000,
          position: "top-right",
        });
      }
    },
    // 获取部门信息
    async getDepartment() {
      try {
        const params = {};
        params.pid = this.userInfo.platformid;
        params.eid = this.userInfo.eid;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.DEPARTMENT, params);
        console.log("返回数据", res);
        this.materialForm.department = res;
      } catch (error) {
        console.log(error);
      }
    },
    // 选择部门
    selectDepart() {
      this.getRoleInfo();
    },
    // 获取角色信息
    async getRoleInfo() {
      try {
        const params = {};
        params.pid = this.userInfo.platformid;
        params.depet = this.depaValue;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.PLANROLE, params);
        console.log("返回数据", res);
        this.materialForm.role = res;
      } catch (error) {
        console.log(error);
      }
    },
    // 搜索部门
    searchDept() {
      this.materialForm.department = this.materialForm.department.filter(
        (item) => item.name === this.inputVal
      );
      if (this.materialForm.department.length === 0) {
        this.isError = true;
      }
    },
    // 清空搜索框
    clearInput() {
      this.isError = false;
      this.getDepartment();
    },
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 800px;
  height: 100%;
  padding: 24px 27px 0;
  box-sizing: border-box;
  background: #f6f8fb;
  .personal {
    width: 100%;
    height: 70px;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    background: #fff;
    margin-bottom: 13px;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #99a9ba;
    padding-left: 28px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      margin-right: 8px;
    }
  }
  .userInfo {
    width: 100%;
    height: 128px;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    background: #fff;
    margin-bottom: 20px;
    padding: 31px 0 0 36px;
    box-sizing: border-box;
    .avatar {
      width: 66px;
      height: 66px;
      margin-right: 20px;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .departmentInfo {
      float: left;
      height: 61px;
      width: calc(100% - 122px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .username {
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #394259;
        margin-bottom: 10px;
      }
      .info {
        display: flex;
        justify-content: space-between;
        span {
          display: inline-block;
          min-width: 200px;
          height: 23px;
          font-size: 15px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #38455a;
          letter-spacing: 1px;
          i {
            font-size: 15px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #969aa5;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
  .panel {
    width: 100%;
    height: 350px;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    background: #fff;
    padding: 0 86px 0 50px;
    box-sizing: border-box;
    > div {
      height: 70px;
      line-height: 70px;
      display: flex;
      justify-content: space-between;
      img {
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-right: 14px;
      }
      .title {
        display: inline-block;
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #263346;
        letter-spacing: 2px;
        margin-right: 4px;
        cursor: pointer;
      }
      .prompt {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #969aa5;
        letter-spacing: 1px;
      }
      .itemRight {
        .point {
          display: inline-block;
          width: 49px;
          height: 22px;
          font-size: 15px;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #969aa5;
          line-height: 22px;
          letter-spacing: 1px;
          margin-right: 15px;
        }
        .modify {
          display: inline-block;
          width: 34px;
          height: 21px;
          font-size: 15px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-decoration: underline;
          text-align: left;
          color: var(--themeColor);
          line-height: 21px;
          letter-spacing: 2px;
          cursor: pointer;
        }
      }
    }
  }
  .logout {
    width: 400px;
    height: 60px;
    margin: 100px auto;
    border-radius: 10px;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    font-size: 24px;
    color: #fff;
    letter-spacing: 3px;
    background: var(--themeColor);
  }
  .dialogHeader {
    display: flex;
    align-items: center;
    img {
      width: 18px;
      height: 17px;
      margin-right: 11px;
    }
    div {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #2c3a50;
    }
  }

  .uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px solid #ccc;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 180px;
    line-height: 180px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .modifyBtn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .deptPhone {
    color: #969aa5;
    margin-left: 10px;
    font-size: 14px;
    letter-spacing: 2px;
  }
  .collapseItem {
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid #e2e5ec;
    .name {
      display: inline-block;
      width: 60px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #858ea2;
      letter-spacing: 1px;
      margin-right: 5px;
    }
    .online {
      display: inline-block;
      width: 28px;
      font-size: 13px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #0ac386;
      letter-spacing: 1px;
      margin-right: 90px;
    }
    .post {
      display: inline-block;
      width: 280px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #858ea2;
      letter-spacing: 1px;
      margin-right: 100px;
    }
    .telephone {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #858ea2;
      letter-spacing: 1px;
    }
  }
  // .canvas {
  //   width: 476px;
  //   height: 200px;
  //   line-height: 200px;
  //   text-align: center;
  //   border: 1px solid rgba(226, 229, 236, 0.62);
  //   .bg {
  //     width: 476px;
  //     height: 200px;
  //     line-height: 200px;
  //     background: #f8fafb;
  //     text-align: center;
  //     font-size: 15px;
  //     color: #838997;
  //   }
  // }
  // .btns {
  //   display: flex;
  //   justify-content: flex-end;
  //   margin-top: 20px;
  // }
  .pic {
    width: 476px;
    height: 200px;
    border: 1px solid #ccc;
    img {
      width: 100%;
      height: 100%;
    }
    .modifySignature {
      display: flex;
      justify-content: flex-end;
    }
  }
  .error {
    font-size: 12px;
    letter-spacing: 1px;
    color: red;
    margin-left: 14px;
  }
}
</style>